import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  Alert,
} from "@mui/material";
import styles from "../css/Form.module.css";

export default function FormAuth() {
  const { preguntaId } = useParams();
  const navigate = useNavigate();

  const [preguntaDetalle, setPreguntaDetalle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [actionType, setActionType] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const preguntas = [
    { id: 1, texto: "¿En su municipio se tiene activada la Mesa técnica de atención a la Desnutrición aguda?" },
    { id: 2, texto: "¿En su municipio se tiene Plan Municipal de intervenciones de acuerdo al análisis de situación?" },
    { id: 3, texto: "¿En su municipio se hizo la identificación de determinantes de la Situación de la Denutrición Aguda?" },
    { id: 4, texto: "¿En el Plan municipal de intervenciones se tiene incluido el Club de Nutrición?" },
    { id: 5, texto: "¿En el Plan municipal de intervenciones se tiene incluida la Estrategia de Comunicación para el Conocimiento familiar y comunitario de DA?" },
    { id: 6, texto: "¿En el Plan municipal de intervenciones se tiene incluida la intensificación de acciones en el tema de Aguas y Saneamiento?" },
    { id: 7, texto: "¿En el Plan municipal de intervenciones se tiene incluida la realización de MODA y la Socialización de los resultados?" },
    { id: 8, texto: "¿En el Plan municipal de intervenciones se tiene incluido el Protocolo de Actuación Conjunta (Asistencia alimentaria, Producción de alimentos, Bono nutrición, Bono salud, Protocolo atención a DA de MSPAS, RSO?" },
    { id: 9, texto: "¿En el Plan municipal de intervenciones se tienen incluidas intervenciones y recursos del Gobierno municipal?" },
    { id: 10, texto: "¿Qué porcentaje de avance se tiene en el Plan Municipal de intervenciones?" },
    { id: 11, texto: "¿En su municipio se han priorizado comunidades para intensificar las acciones?" },
    { id: 12, texto: "¿Cuántas comunidades han sido priorizadas en su municipio?" },
    { id: 13, texto: "¿Cuántas comunidades priorizadas tienen redes de apoyo en su municipio?" },
    { id: 14, texto: "¿Cuál es el número total (acumulado) de niñas y niños con desnutrición aguda, del listado nominal, que han sido monitoreados?" },
    { id: 15, texto: "¿Cuál es el porcentaje de niñas y niños con Desnutrición Aguda Monitoreados a la fecha? " },
    { id: 16, texto: "¿En la reunión mensual de COMUSAN del municipio, se realizó presentación de resultados de MODA? " },
    { id: 17, texto: "¿En la COMUSAN de su municipio se elaboró informe registrando avances, desafíos y gestiones realizadas a nivel territorial y central?" },
    { id: 18, texto: "¿Ha inicios del mes que se está reportando recibieron el listado nominal de niñas y niños con Desnutrición aguda?" },
    { id: 19, texto: "¿Cuál es el número total (acumulado) de niñas y niños con desnutrición aguda, que cuentan CON CUI, que han sido incluidos en el listado nominal?" },
    { id: 20, texto: "¿Cuál es el número acumulado de niñas y niños con desnutrición aguda, SIN CUI que han sido incluidos en el listado nominal?" },
    { id: 21, texto: "¿Cuál es el número acumulado de niñas y niños que han sido localizados y trasladados a la delegación departamental para su reporte a Oficinas centrales?" },
    { id: 22, texto: "¿Cuál es el porcentaje de niñas y niños con Desnutrición Aguda, SIN CUI, que han sido localizados en el municipio?" },
    { id: 23, texto: "¿En el municipio se cuenta con el registro de familias que han sido beneficiadas con programas sociales o institucionales?" },
    { id: 24, texto: "¿Cuántas familias de niños con Desnutrición aguda, reciben el Bono Nutrición?" },
    { id: 25, texto: "¿Cuántas familias de niños con Desnutrición aguda, reciben Asistencia alimentaria por NDA?" },
    { id: 26, texto: "¿Cuántas familias de niños con Desnutrición aguda, reciben Atención del MSPAS?" },
    { id: 27, texto: "¿Cuántas familias de niños con Desnutrición aguda, reciben Asistencia técnica de MAGA para producción agropecuaria?" },
    { id: 28, texto: "¿Cuántas niñas y niños con Desnutrición aguda, del listado nominal, corresponden a las comunidades priorizadas?" },
    { id: 29, texto: "¿Cuántas niñas y niños con Desnutrición aguda, que corresponden a las comunidades priorizadas, han sido monitoreados?" },
  ];

  useEffect(() => {
    const fetchDetalle = async () => {
      setLoading(true);
      try {
        const res = await fetch(`/preguntas/${preguntaId}`);
        if (!res.ok) throw new Error("Pregunta no encontrada");
        const data = await res.json();
        setPreguntaDetalle(data);
      } catch (err) {
        console.error("Error al obtener detalle de pregunta:", err);
        setSnackbar({
          open: true,
          message: "Error al obtener detalle de la pregunta",
          severity: "error",
        });
      } finally {
        setLoading(false);
      }
    };

    if (preguntaId) fetchDetalle();
  }, [preguntaId]);

  const handleOpenDialog = (type) => {
    setActionType(type);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setActionType("");
  };

  const handleConfirmAction = async () => {
    try {
      let res;
      if (actionType === "eliminar") {
        res = await fetch(`/preguntas/${preguntaId}`, {
          method: "DELETE",
        });
      } else if (actionType === "autorizar") {
        res = await fetch(`/preguntas/${preguntaId}/autorizar`, {
          method: "PUT",
        });
      }

      if (!res.ok) throw new Error("Error al realizar la acción");

      const successMessage =
        actionType === "eliminar"
          ? "Pregunta eliminada correctamente."
          : "Pregunta autorizada correctamente.";

      setSnackbar({ open: true, message: successMessage, severity: "success" });
      handleCloseDialog();

      setTimeout(() => navigate("/autorizacion"), 1500);
    } catch (err) {
      console.error(err);
      setSnackbar({
        open: true,
        message: "Ocurrió un error al procesar la acción.",
        severity: "error",
      });
      handleCloseDialog();
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  if (loading) return <Typography>Cargando...</Typography>;
  if (!preguntaDetalle) return <Typography>No se encontró la pregunta.</Typography>;

  const dialogText =
    actionType === "eliminar"
      ? `¿Está seguro que desea eliminar la encuesta del usuario ${preguntaDetalle?.nombre_completo}, del departamento de ${preguntaDetalle?.departamento}, en el municipio de ${preguntaDetalle?.municipio}?`
      : `¿Desea autorizar la encuesta del usuario ${preguntaDetalle?.nombre_completo}, del departamento de ${preguntaDetalle?.departamento}, en el municipio de ${preguntaDetalle?.municipio}?`;

  const dialogTitle =
    actionType === "eliminar" ? "Confirmar eliminación" : "Confirmar autorización";

  return (
    <Paper elevation={6} className={styles.paper}>
      <Typography variant="h5" gutterBottom className={styles.title}>
        Detalle de Respuesta
      </Typography>

      <Box className={styles.formContainer}>
        <TextField
          label="Usuario que llenó la encuesta"
          value={preguntaDetalle.nombre_completo || ""}
          fullWidth
          sx={{ mb: 2 }}
          disabled
        />

        <TextField
          label="Fecha de ingreso de la encuesta"
          value={
            preguntaDetalle.fecha_registro
              ? new Date(preguntaDetalle.fecha_registro).toLocaleDateString()
              : ""
          }
          fullWidth
          sx={{ mb: 2 }}
          disabled
        />

        <TextField
          label="Departamento"
          value={preguntaDetalle.departamento || ""}
          fullWidth
          sx={{ mb: 2 }}
          disabled
        />

        <TextField
          label="Municipio"
          value={preguntaDetalle.municipio || ""}
          fullWidth
          sx={{ mb: 2 }}
          disabled
        />

        {preguntas.map((preg) => (
          <Box key={preg.id} sx={{ mb: 2 }}>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
              {preg.id}. {preg.texto}
            </Typography>
            <TextField fullWidth value={preguntaDetalle[`pregunta${preg.id}`] || ""} disabled />
          </Box>
        ))}

        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="outlined" onClick={() => navigate("/autorizacion")} fullWidth>
            Regresar
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => handleOpenDialog("eliminar")}
            fullWidth
          >
            Eliminar
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleOpenDialog("autorizar")}
            fullWidth
          >
            Autorizar
          </Button>
        </Box>
      </Box>

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText>{dialogText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="inherit">
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmAction}
            color={actionType === "eliminar" ? "error" : "primary"}
            variant="contained"
            autoFocus
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Paper>
  );
}
